import { createBrowserRouter, Navigate } from "react-router-dom";
import { Me } from "~/layouts";
import Budgets from "~/routes/budgets";
import Login from "~/routes/login";

const router = createBrowserRouter([
    {
        path: "/login",
        element: <Login />,
    },
    {
        // @dependency: the backend's magic-link verify/error redirects are
        // hardcoded to `{APP_WEB_URL}/budgets` and `{APP_WEB_URL}/budgets/:id` -
        // keep this path in sync with client-portal-backend's src/routes/auth.rs.
        path: "/budgets",
        element: <Me />,
        children: [
            { index: true, element: <Budgets /> },
            { path: ":id", element: <Budgets /> },
        ],
    },
    {
        path: "*",
        element: <Navigate to="/budgets" replace />,
    },
]);

export default router;
